// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	TitleSection: 'title-section',
	SetDefaultProviderSelect: 'set-default-provider-select',
	IdvProviderOption: 'idv-provider-option',
} as const;
